import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FeaturePlaylistService} from '@catmodels/avod-catalog/services/feature-playlist.service';
import {ProjectPlaylistService} from '@catmodels/avod-catalog/services/project-playlist.service';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {StyleType} from '@catui/types';
import {isNullOrUndefined} from 'util';

@Component({
  selector: 'catapp-create-playlist',
  templateUrl: './create-playlist.component.html',
  styleUrls: ['./create-playlist.component.scss'],
})
export class CreatePlaylistComponent implements OnInit {

  @Output() afterCreate = new EventEmitter<any>();

  @Input() title: string;

  @Input()
  get source(): any {
    return this._source;
  }

  set source(value: any) {
    this._source = value;
    if (!isNullOrUndefined(value)) {
      this.form.patchValue({avod_catalog: value});
    }
  }

  @Input() isFeature = false;

  get readyToSubmit() {
    let isReady = !isNullOrUndefined(this.form);
    isReady = isReady && !isNullOrUndefined(this.source);
    isReady = isReady && this.form.dirty && this.form.valid;
    return isReady;
  }

  labels = {
    avodCatalog: 'AVoD Catalog',
    name: 'Name',
    path: 'Path',
    sync: 'Sync with Settingsserver',
  };
  controlRefs = {
    avodCatalog: 'avod_catalog',
    name: 'name',
    path: 'path',
    sync: 'syncWithSettings',
  };

  form: FormGroup;
  styleType = StyleType;

  private _source = {};

  constructor(private formBuilder: FormBuilder,
              private featPlaylistService: FeaturePlaylistService,
              private proPlaylistService: ProjectPlaylistService,
              private activeModal: ActiveModal) {

    this.form = this.formBuilder.group({
      avod_catalog: this.formBuilder.control(null, [Validators.required]),
      name: this.formBuilder.control('', [Validators.required]),
      path: this.formBuilder.control(null, []),
      syncWithSettings: this.formBuilder.control(false, []),
    });
  }

  ngOnInit() {
  }

  createPlaylist() {
    let service;
    if (this.isFeature) {
      service = this.featPlaylistService;
    } else {
      service = this.proPlaylistService;
    }

    const subscribebable = service.create({
      avod_catalog: this._source,
      name: this.form.value.name,
      path: this.form.value.path,
      syncWithSettings: this.form.value.syncWithSettings,
    });
    subscribebable.subscribe((playlist: any) => {
      this.afterCreate.emit(playlist);
      this.activeModal.close(playlist);
    });
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/avod-catalog/components/create-playlist/create-playlist.component.ts